// // file name ImpFunc.js
// export function getMissingFloors(targetObjects) {
//   const missingFloors = [];

//   // Create a Set of all normalized locations (without '*')
//   const locationSet = new Set(
//     targetObjects.map(obj => {
//       let loc = obj.last_stk_loc ?? '';
//       return loc.endsWith('*') ? loc.slice(0, -1) : loc;
//     })
//   );

//   targetObjects.forEach((data) => {
//     if (!data.last_stk_loc) return;

//     let rawLoc = data.last_stk_loc;
//     rawLoc = rawLoc.endsWith('*') ? rawLoc.slice(0, -1) : rawLoc;

//     const floor = rawLoc.slice(-1);
//     // const baseLoc = rawLoc.slice(0, -1);
//     const  baseLoc = (rawLoc.replace('/', '-').slice(0, -1));
//     const currentFloorCode = floor.toUpperCase().charCodeAt(0);
//     for (let code = 65; code < currentFloorCode; code++) { // 'A' = 65
//       const checkFloor = String.fromCharCode(code); // 'A', 'B', ...
//       const checkLoc = baseLoc + checkFloor;

//       if (!locationSet.has(checkLoc)) {
//         // Prevent duplicates
//         if (!missingFloors.some(entry => entry.locationName === baseLoc && entry.missingFloor === checkFloor)) {
//           missingFloors.push({
//             locationName: baseLoc,
//             missingFloor: checkFloor
//           });
//         }
//       }
//     }
//   });

//   return missingFloors;
// }



export function getMissingFloors(targetObjects) {
  const missingFloors = [];

  const locationSet = new Set(
    targetObjects.map(obj => {
      let loc = obj.last_stk_loc ?? '';
      loc = loc.endsWith('*') ? loc.slice(0, -1) : loc;
      return loc.replace('/', '-');
    })
  );

  targetObjects.forEach((data) => {
    if (!data.last_stk_loc) return;

    let rawLoc = data.last_stk_loc;
    rawLoc = rawLoc.endsWith('*') ? rawLoc.slice(0, -1) : rawLoc;

    const floor = rawLoc.slice(-1);
    const baseLoc = rawLoc.replace('/', '-').slice(0, -1);
    const currentFloorCode = floor.toUpperCase().charCodeAt(0);

    for (let code = 65; code < currentFloorCode; code++) {
      const checkFloor = String.fromCharCode(code); // 'A', 'B', ...
      const checkLoc = baseLoc + checkFloor;

      if (!locationSet.has(checkLoc)) {
        if (!missingFloors.some(entry =>
          entry.locationName === baseLoc && entry.missingFloor === checkFloor)) {
          missingFloors.push({
            locationName: baseLoc,
            missingFloor: checkFloor
          });
        }
      }
    }
  });

  return missingFloors;
}
